/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionCatalogStatsDto } from '../../models/auction-catalog-stats-dto';

export interface GetAuctionCatalogStats$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getAuctionCatalogStats(http: HttpClient, rootUrl: string, params: GetAuctionCatalogStats$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionCatalogStatsDto>> {
  const rb = new RequestBuilder(rootUrl, getAuctionCatalogStats.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuctionCatalogStatsDto>;
    })
  );
}

getAuctionCatalogStats.PATH = '/api/auction-catalogs/{id}/stats';
